// Ganesha oracle - standalone per-route bundle, no Stimulus.
//
// Built as its own IIFE entry point (see package.json) and loaded only on
// /frage-ganesha via `javascript_include_tag "ganesha"`, so the ported
// mini-apps never bloat the global bundle or touch the Stimulus registry
// (avoids the cross-bundle Stimulus breakage from 2026-06-08).
//
// Turbo-safe: a per-element guard makes init idempotent, and the turbo:load
// listener is registered once at window scope so repeat visits don't stack
// listeners.
(function () {
  var TYPE_MS = 45; // per-character delay for the "Ganesha speaks" effect

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function init() {
    var root = document.querySelector("[data-ganesha]");
    if (!root || root.dataset.gBooted) return;

    var answers;
    try {
      answers = JSON.parse(root.dataset.answers || "[]");
    } catch (e) {
      return;
    }
    if (!answers.length) return;

    var askButton = root.querySelector("[data-ganesha-ask]");
    var againButton = root.querySelector("[data-ganesha-again]");
    var intro = root.querySelector("[data-ganesha-intro]");
    var result = root.querySelector("[data-ganesha-result]");
    var textEl = root.querySelector("[data-ganesha-text]");
    var announceEl = root.querySelector("[data-ganesha-announce]");
    var cursor = root.querySelector("[data-ganesha-cursor]");
    if (!askButton || !result || !textEl) return;

    root.dataset.gBooted = "1";

    var typingTimer = null;
    var lastIndex = -1;

    // Pick a random answer, avoiding an immediate repeat so "nochmals" feels fresh.
    function randomAnswer() {
      if (answers.length === 1) return answers[0];
      var i = lastIndex;
      while (i === lastIndex) {
        i = Math.floor(Math.random() * answers.length);
      }
      lastIndex = i;
      return answers[i];
    }

    function typeOut(text) {
      if (typingTimer) clearInterval(typingTimer);
      textEl.textContent = "";
      // Announce the whole sentence once to screen readers, independent of the
      // per-character reveal that drives the visible (aria-hidden) line.
      if (announceEl) announceEl.textContent = text;
      if (cursor) cursor.classList.add("is-typing");

      if (prefersReducedMotion()) {
        textEl.textContent = text;
        if (cursor) cursor.classList.remove("is-typing");
        return;
      }

      var i = 0;
      typingTimer = setInterval(function () {
        textEl.textContent += text.charAt(i);
        i += 1;
        if (i >= text.length) {
          clearInterval(typingTimer);
          typingTimer = null;
          if (cursor) cursor.classList.remove("is-typing");
        }
      }, TYPE_MS);
    }

    function ask() {
      if (intro) intro.classList.add("hidden");
      askButton.classList.add("hidden");
      result.classList.remove("hidden");
      result.classList.add("fade-in");
      if (againButton) againButton.classList.remove("hidden");
      typeOut(randomAnswer());
    }

    askButton.addEventListener("click", ask);
    if (againButton) {
      againButton.addEventListener("click", function () {
        result.classList.remove("fade-in");
        // Force reflow so the fade-in animation can replay on the next answer.
        void result.offsetWidth;
        result.classList.add("fade-in");
        typeOut(randomAnswer());
      });
    }
  }

  if (!window.__ganeshaBooted) {
    window.__ganeshaBooted = true;
    document.addEventListener("turbo:load", init);
  }

  init();
})();
